<template>
  <div class="list">
    <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline form-wrap">
      <el-form-item>
        <el-input
          v-model="listQuery.keyword_search"
          clearable
          style="width: 300px"
          class="name-input"
          placeholder="请输入关键词"
        />
      </el-form-item>
      <el-form-item class="add">
        <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
        <el-button v-if="hasAddAdmin" type="primary" size="small" icon="el-icon-plus" @click="onAddAdminClick"
          >添加管理员</el-button
        >
      </el-form-item>
    </el-form>

    <el-table v-loading="listLoading" :data="list" border style="width: 100%">
      <el-table-column prop="name" label="管理员名称" />
      <el-table-column prop="account" label="管理员账号" />
      <el-table-column prop="group_title" label="角色" />
      <el-table-column prop="login_time" label="最后登录时间" />
      <el-table-column prop="create_time" label="创建时间" />
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button v-if="hasEditAdmin" type="primary" size="small" @click="handleEditClick(scope.row.uuid)"
            >编辑</el-button
          >
          <el-button v-if="hasDeleteAdmin" type="danger" size="small" @click="handleDeleteClick(scope.row.uuid)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>
  </div>
</template>
<script>
import { getManagerList, deleteAdmin } from "@/api/auth";
import Pagination from "@/components/Pagination";
import operations from "../../mixins/operations";

export default {
  components: { Pagination },
  mixins: [operations],
  data() {
    return {
      list: [],
      roleList: [],
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      listLoading: false,
    };
  },
  computed: {
    hasAddAdmin() {
      return this.operations.includes("新建管理员");
    },
    hasEditAdmin() {
      return this.operations.includes("编辑管理员");
    },
    hasDeleteAdmin() {
      return this.operations.includes("删除管理员");
    },
  },
  async mounted() {
    this.getList();
  },
  methods: {
    async getList(params = this.listQuery) {
      this.listLoading = true;
      const { total, data } = await getManagerList(params);
      this.listLoading = false;

      this.total = total;
      this.list = data;
    },
    onAddAdminClick() {
      this.$router.push({
        path: "/add-admin",
      });
    },
    handleEditClick(uuid) {
      this.$router.push({
        path: "/edit-admin",
        query: { uuid },
      });
    },
    handleDeleteClick(uuid) {
      this.$confirm(`是否删除该管理员？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await deleteAdmin(uuid);
        this.getList();
        this.$notify({ title: "操作成功", type: "success" });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.form-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
